import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/end-reasons.js';
import q from '../query.js';
export const endReasonsEntity = 'end-reasons';
const endReasonsKey = `end-reasons`;
export const useEndReasons = () => q.query(endReasonsKey, api.getAll, keys.read.collection(endReasonsEntity));
//# sourceMappingURL=index.js.map